import React, { useEffect, useRef } from "react";
import "./HamburgerMenu.css";

const HamburgerMenu = ({ isOpen, onClose }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleBackClick = (e) => {
    e.stopPropagation();
    const backIcon = e.currentTarget;
    backIcon.style.transform = 'translateX(-10px)';
    
    setTimeout(() => {
        backIcon.style.transform = 'translateX(0)';
        onClose();
    }, 150);
};

  return (
    <>
      <div className={`menu-overlay ${isOpen ? 'open' : ''}`} />
      <div 
        ref={menuRef}
        className={`hamburger-menu-container ${isOpen ? 'open' : ''}`}
      >
        <div className="menu-header">
          <button 
            className="back-icon" 
            onClick={handleBackClick}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <span className="brand-name">Agently</span>
        </div>

        <div className="menu-content">
          <div className="menu-item">
            <input type="radio" id="profile" name="menu" defaultChecked />
            <label htmlFor="profile">Profile</label>
          </div>
          <div className="menu-item">
            <input type="radio" id="saved-styles" name="menu" />
            <label htmlFor="saved-styles">Saved Styles</label>
          </div>
          <hr style={{
            border: 'none',
            height: '1px',
            backgroundColor: '#3D3D3D',
            margin: ' 0'
          }} />
          <div className="menu-history">
            <h3>Your History</h3>
            <div className="history-item">
              <span className="history-date">1st Nov 2024</span> - Jordans, Sneak..
            </div>
            <div className="history-item">
              <span className="history-date">14th Oct 2024</span> - Jordans, Sneak..
            </div>
            <div className="history-item">
              <span className="history-date">2nd Aug 2024</span> - Yzy, Nike dunks SB hallow..
            </div>
          </div>
        </div>
        <hr style={{
            border: 'none',
            height: '1px',
            backgroundColor: '#3D3D3D',
            margin: ' 0'
          }} />
        <div className="menu-footer">
          <span>Made with <img src="/Heart.png" alt="heart" /> in India</span>
          <div style={{ marginTop: '8px', fontSize: '12px', opacity: 0.7 }}>
            Powered by Agently
          </div>
        </div>
      </div>
    </>
  );
};

export default HamburgerMenu; 